import LanguageSwitcher from '@/components/language-switcher';
import templateLandingDeviceMockup from '@/modules/auth/assets/template-landing-device-mockup';
import TemplateFooterLinks from '@/modules/auth/components/auth-template-footer-links';
import Branding from '@/modules/auth/components/branding';
import config from '@/modules/config/functions/config';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Image, Typography } from '@thisisdmg/tirecloud-patterns/v2';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './index.module.css';

function AuthTemplate() {
  const { i18n } = useTranslation();

  const appName = useMemo(() => {
    return config(
      `app.name.${i18n.language}`,
      config('app.name.__default__', 'TireCloud<wbr/>.One')
    );
  }, [i18n.language]);

  return (
    <div className={classes.auth_template_wrapper}>
      <div className={classes.auth_template}>
        <div className={classes.auth_template__landing}>
          <div className={classes.auth_template__landing__header}>
            <Branding />
            <div
              className={
                classes.auth_template__landing__header__language_switcher
              }
            >
              <LanguageSwitcher />
            </div>
          </div>
          <div className={classes.auth_template__landing__content}>
            <div className={classes.auth_template__landing__content__container}>
              <div className={classes.auth_template__landing__content__image}>
                <Image
                  src={templateLandingDeviceMockup}
                  alt={appName.replace(/<wbr\s*\/>/g, '')}
                  preview={false}
                />
              </div>
              <div className={classes.auth_template__landing__content__text}>
                <Typography
                  variant="hero"
                  element="h2"
                  className={
                    classes.auth_template__landing__content__text__title
                  }
                  dangerouslySetInnerHTML={{
                    __html: appName,
                  }}
                />
                <Typography
                  variant="body"
                  element="p"
                  className={
                    classes.auth_template__landing__content__text__description
                  }
                  dangerouslySetInnerHTML={{
                    __html: config(
                      `app.description.${i18n.language}`,
                      config(
                        'app.description.__default__',
                        'TireCloud<wbr/>.One'
                      )
                    ),
                  }}
                />
              </div>
            </div>
          </div>
          <div className={classes.auth_template__landing__footer}>
            <TemplateFooterLinks htmlClasses={classes} />
            <div
              className={
                classes.auth_template__landing__footer__language_switcher
              }
            >
              <LanguageSwitcher />
            </div>
          </div>
        </div>
        <div className={classes.auth_template__form}>
          <div className={classes.auth_template__form__container}>
            <Outlet />
          </div>
        </div>
      </div>
      <div className={classes.auth_template__background_text}>
        <h6>
          {config(
            `app.name.en`,
            config('app.name.__default__', 'TireCloud.One')
          ).replace(/<wbr\s*\/>/g, '')}
        </h6>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_auth')({
  component: AuthTemplate,
  beforeLoad({ context, search }) {
    // user is in the process of logging out, so we don't need to redirect back
    if (
      context.userState.status === 'authenticated' &&
      search.action !== 'logout' &&
      search.action !== 'force_logout'
    )
      throw redirect({
        to: search.redirect ?? '/',
      });
  },
});
